import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useAuthContext } from './context';
import {
  verifyOTP as verify,
  register,
  authenticate,
  socialAuthenticate
} from './api';

const useAPI = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('ready');
  const [errors, setErrors] = useState({});
  const { actions: { initAuth } } = useAuthContext();

  const setErrorMessages = (errorMessage) => {
    switch (errorMessage) {
      case 'EMAIL_IS_NOT_UNIQUE':
        setErrors({ ...errors, email: 'عنوان البريد الإلكتروني مستخدم بالفعل' });
        break;
      case 'REQUIRED_PASSWORD':
        setErrors({ ...errors, password: 'كلمة السر مطلوبة' });
        break;
      case 'REQUIRED_PASSWORD_CONFIRMATION':
        setErrors({ ...errors, passwordConfirmation: 'تأكيد كلمة السر مطلوب' });
        break;

      case 'PASSWORD_CONFIRMATION_MISMATCH':
        setErrors({ ...errors, passwordMismatch: 'كلمة السر لا تطابق التأكيد', passwordConfirmation: 'كلمة السر لا تطابق التأكيد' });
        break;

      default:
        break;
    }
  };

  const login = async (payload) => {
    try {
      const { data } = await authenticate(payload);
      const storedBookingURL = localStorage.getItem('pendingBookingURL');
      const storedBookingState = localStorage.getItem('pendingBookingState');

      if (data && data.success) {
        initAuth(data);
        if (storedBookingURL && storedBookingState) {
          navigate(storedBookingURL, { state: JSON.parse(storedBookingState) });

          localStorage.removeItem('pendingBookingURL');
          localStorage.removeItem('pendingBookingState');
        } else navigate('../');
      }
      else {
        setErrors({ message: 'فشل في الدخول' });
        setStatus('submit_failed');
      }
    } catch (error) {
      if (error.networkError) {
        setErrors({ message: 'لرجاء التحقق من الإتصال بالإنترنت' });
      } else setErrors({ message: 'فشل في الدخول' });
      setStatus('submit_failed');
    }
  };

  const signup = async ({ payload, provider = 'email' }) => {
    setStatus('submitting');
    try {
      const { data } = await register({ payload, provider });

      if (data && data.success) {
        navigate('../email_confirmation', { state: data.user });
      } else {
        if (data.errors) setErrors(data.errors);
        else setErrorMessages(data.error);
        setStatus('failed');
      }
    } catch (error) {
      if (error.response) {
        setErrorMessages(error.response.data);
        setStatus('submit_failed');
      }
      if (error.networkError) {
        setErrors({ message: 'لرجاء التحقق من الإتصال بالإنترنت' });
        setStatus('network_failure');
      }
    }
  };

  const socialLogin = async (payload, callback) => {
    setStatus('submitting');

    try {
      const { data } = await socialAuthenticate(payload);

      if (data && data.success) {
        initAuth(data);
        if (typeof callback === 'function') callback();
        else navigate('../');
      } else {
        setErrors({ message: 'ثمة خطأ ما!' });
        setStatus('submit_failed');
      }
    } catch (error) {
      setErrors({ message: 'ثمة خطأ ما!' });
      setStatus('submit_failed');
    }
  };

  const verifyOTP = async ({ email, otp, fullName }) => {
    setStatus('submitting');

    try {
      const { data } = await verify({ email, otp });

      if (data && data.success) {
        initAuth(data);
        navigate('../', { state: { message: `تم إنشاء حساب المستخدم بنجاح, مرحبا بك ${fullName} في كويندا !` } });
      }
      else {
        setErrors({ message: 'الرمز غير صالح' });
        setStatus('submit_failed');
      }
    } catch (error) {
      setErrors({ message: 'الرمز غير صالح' });
      setStatus('submit_failed');
    }
  };

  return {
    actions: { login, signup, verifyOTP, socialLogin,setErrors },
    data: {},
    status,
    errors,
  };
};

export default useAPI;
